import React from 'react';

export default class Hover extends React.Component {
  constructor() {
    super();
    this.state = { isHovering: false };
    this.toggleHover = this.toggleHover.bind(this);
  }

  toggleHover() {
    this.setState(({ isHovering }) => ({ isHovering: !isHovering }));
  }

  render() {
    const { isHovering } = this.state;
    const { children } = this.props;

    return (
      <div onMouseEnter={this.toggleHover} onMouseLeave={this.toggleHover}>
        {children(isHovering)}
      </div>
    );
  }
}
